import { takeLatest, call, put, all } from 'redux-saga/effects';

import { 
  fetchBanners,
  fetchHighlightFunds,
  fetchTopSubCategories,
  fetchArticles
} from '../_services/home.services';

import {
  fetchNavForAdvanceSearch
} from '../_services/advance-search.services';

import { 
  fetchBannersSuccess, 
  fetchBannersFailure,
  fetchHighlightFundsSuccess,
  fetchHighlightFundsFailure,
  updateNavFunds,
  fetchNavFundsSuccess,
  fetchNavFundsFailure,
  fetchTopSubCategoriesSuccess,
  fetchTopSubCategoriesFailure,
  fetchArticlesSuccess,
  fetchArticlesFailure,
 } from '../_actions/home.actions';

import { homeConstants } from '../_constants/home.constants';

export function* fetchBannersStartAsync() {
  try {
    const result = yield call(fetchBanners);
    yield put(fetchBannersSuccess(result.data));
  } catch (error) {
    yield put(fetchBannersFailure(error.message));
  }
}

export function* fetchHighlightFundsStartAsync({payload}) {
  try {
    const result = yield call(fetchHighlightFunds, payload);
    yield put(updateNavFunds(result.data));
    yield put(fetchHighlightFundsSuccess(result.data));
  } catch (error) {
    yield put(fetchHighlightFundsFailure(error.message));
  }
}

export function* fetchNavFundsAsync({ payload }) {
	try {
		const result = yield call(fetchNavForAdvanceSearch, payload);
		yield put(fetchNavFundsSuccess(result.data));
	} catch (error) {
		yield put(fetchNavFundsFailure(error));
	}
}

export function* fetchTopSubCategoriesStartAsync() {
  try {
    const result = yield call(fetchTopSubCategories);
    yield put(fetchTopSubCategoriesSuccess(result.data));
  } catch (error) {
    yield put(fetchTopSubCategoriesFailure(error.message));
  }
}

export function* fetchArticlesStartAsync() {
  try {
    const result = yield call(fetchArticles);
    yield put(fetchArticlesSuccess(result.data));
  } catch (error) {
    yield put(fetchArticlesFailure(error.message));
  }
}

export function* fetchBannersStart() {
  yield takeLatest(homeConstants.FETCH_BANNERS_START, fetchBannersStartAsync);
}

export function* fetchHighlightFundsStart() {
  yield takeLatest(homeConstants.FETCH_HIGHLIGHT_FUNDS_START, fetchHighlightFundsStartAsync);
}

export function* fetchNavFundsStart() {
  yield takeLatest(homeConstants.FETCH_NAV_FUNDS_START, fetchNavFundsAsync);
}

export function* fetchTopSubCategoriesStart() {
  yield takeLatest(homeConstants.FETCH_TOP_SUB_CATEGORIES_START, fetchTopSubCategoriesStartAsync);
}

export function* fetchArticlesStart() {
  yield takeLatest(homeConstants.FETCH_ARTICLES_START, fetchArticlesStartAsync);
}

export function* HomeSagas() {
  yield all([call(fetchBannersStart), call(fetchHighlightFundsStart), call(fetchTopSubCategoriesStart), call(fetchArticlesStart), call(fetchNavFundsStart)]);
}
